import { RefLinkType } from "../../enums/refLinkType";

export class RefLinkSettingsPostRequest {
    id: number;
    userId: number;
    invitesLimit: number;
    refName: string;
    refLinkType: RefLinkType;
}